var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5999 1.95464H11.8998V1.22732C11.8998 1.03442 11.8261 0.849426 11.6948 0.713027C11.5635 0.576628 11.3855 0.5 11.1998 0.5C11.0141 0.5 10.8361 0.576628 10.7048 0.713027C10.5735 0.849426 10.4997 1.03442 10.4997 1.22732V1.95464H3.50025V1.22732C3.50025 1.03442 3.4265 0.849426 3.29521 0.713027C3.16393 0.576628 2.98587 0.5 2.8002 0.5C2.61454 0.5 2.43648 0.576628 2.30519 0.713027C2.17391 0.849426 2.10015 1.03442 2.10015 1.22732V1.95464H1.4001C1.0291 1.95575 0.673597 2.10936 0.411258 2.38192C0.148919 2.65448 0.0010661 3.02383 0 3.40928V15.0454C0.0010661 15.4308 0.148919 15.8002 0.411258 16.0727C0.673597 16.3453 1.0291 16.4989 1.4001 16.5H12.5999C12.9709 16.4989 13.3264 16.3453 13.5887 16.0727C13.8511 15.8002 13.9989 15.4308 14 15.0454V3.40928C13.9989 3.02383 13.8511 2.65448 13.5887 2.38192C13.3264 2.10936 12.9709 1.95575 12.5999 1.95464ZM11.8998 15.0454H2.10116C1.91607 15.0434 1.73908 14.9662 1.60819 14.8302C1.4773 14.6942 1.40295 14.5103 1.40111 14.318V5.59124H12.5999V14.3191C12.5978 14.5112 12.5233 14.6948 12.3925 14.8306C12.2616 14.9664 12.0848 15.0435 11.8998 15.0454Z",
    fill: "#323338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/CalendarIcon.f79efa904653614a3c921df4c4ba6e41.svg";
export { ForwardRef as ReactComponent };